import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class DataSharingAccessGuard implements CanActivate {

  constructor(
    private router: Router,
    private api: ApiService
  ) { }

  async canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Promise<boolean> {
    try {
      const retailer = await this.api.retailers.getByAuthAsync();
      if (retailer.enableDataSharing) {
        return true;
      }
    } catch {
      // No-op: if lookup fails, deny access.
    }

    this.router.navigate(['/']);
    return false;
  }
}
